import React from "react";
import StaticPostLayout from "../components/StaticPostLayout";
import MapAcadiaNationalPark from "../components/Maps/acadia-national-park";
import AcadiaNationalParkInfo from "../components/TripInfo/acadia-national-park";

class AcadiaNationalPark extends React.Component {
  render() {
    return (
      <StaticPostLayout
        title="Acadia National Park: 3-Day Itinerary"
        category="National Parks"
        slug="acadia-national-park-itinerary"
        excerpt="Mountains meet the Atlantic on Maine's Mount Desert Island — granite cliffs, sunrise on Cadillac Mountain, and the famous Jordan Pond House popovers."
        tags={["National Parks", "Hiking", "East Coast", "Maine", "Coastal"]}
        readTime="7 min read"
        mapComponent={<MapAcadiaNationalPark />}
        whereToStay={[
          { name: 'Hotels in Bar Harbor', type: 'Main Hub · Mount Desert Island', url: 'https://www.booking.com/searchresults.html?ss=Bar+Harbor%2C+Maine' },
          { name: 'Southwest Harbor Inns', type: 'Quieter side · Acadia NP', url: 'https://www.booking.com/searchresults.html?ss=Southwest+Harbor%2C+Maine' },
          { name: 'Hotels in Ellsworth', type: 'Budget Gateway · 30 min away', url: 'https://www.booking.com/searchresults.html?ss=Ellsworth%2C+Maine' },
        ]}
      >
        <AcadiaNationalParkInfo />
      </StaticPostLayout>
    );
  }
}

export default AcadiaNationalPark;
